import React from 'react';
import { BasketItem } from '@common/components/BasketItem';
import BASKET_UPDATE_TYPES from '@common/constants/BasketUpdateTypes';
import { Routes } from '@common/constants';
import { SpaDetails } from './SpaDetails';
import { SpaMetadata } from './SpaMetadata';
import { SpaPackageItems } from './SpaDetails/SpaPackageItems';
import { PackageItineraryWrapper, SpaItemName } from './SpaItem.styles';

export type SpaItemProps = {
  onChange: (
    type: BASKET_UPDATE_TYPES.REMOVE | BASKET_UPDATE_TYPES.QUANTITY,
    itemId: number
  ) => void;
  item: any;
  isEditable: boolean;
  hideArrivalTimes?: boolean;
  hidePrice?: boolean;
  hideGuestDetails?: boolean;
  isPackage?: boolean;
};

export const SpaItem: React.FC<SpaItemProps> = ({
  onChange,
  item,
  isEditable = false,
  hideArrivalTimes = false,
  hidePrice,
  hideGuestDetails,
  isPackage,
}) => {
  const {
    bookable: { name, imageUrl, id, ids },
    checkIn,
    price,
    discount,
    type,
    guestDetails,
    selectionGroups,
    spaPackage,
    dynamicPackage,
  } = item;
  const linkParams = {
    ...(type !== 'spa-classes' && {
      id: spaPackage?.id || ids?.id,
    }),
  };

  const isOvernightPackage = isPackage || !!dynamicPackage;

  const routes = {
    'spa-treatments': Routes.SPA_TREATMENT_DETAIL,
    'spa-days': Routes.SPA_DAY_DETAIL,
    'spa-packages': Routes.SPA_DAY_DETAIL,
    'spa-classes': Routes.SPA_CLASSES_LIST,
  };
  const routeName = routes[type];

  function renderSpaMetadata() {
    return (
      <SpaMetadata
        checkIn={checkIn}
        guestDetails={guestDetails}
        hideArrivalTimes={hideArrivalTimes}
      />
    );
  }

  function handleSpaItemRemoval() {
    onChange(BASKET_UPDATE_TYPES.REMOVE, item.id);
  }

  const shouldRenderMobileDetails = Boolean(guestDetails);
  const renderDetails = () => {
    if (isOvernightPackage) {
      return (
        <PackageItineraryWrapper>
          <SpaItemName>{item.bookable.name}</SpaItemName>
          <SpaPackageItems guestDetails={guestDetails} selectionGroups={selectionGroups} />
        </PackageItineraryWrapper>
      );
    }

    if (!hideGuestDetails) {
      return <SpaDetails guestDetails={guestDetails} selectionGroups={selectionGroups} />;
    }

    return <></>;
  };
  return (
    <BasketItem
      key={id}
      isEditable={isEditable}
      linkParams={linkParams}
      linkRoute={routeName}
      name={isOvernightPackage ? '' : name}
      onRemove={handleSpaItemRemoval}
      price={discount?.standardPrice || price}
      discount={discount}
      renderDetails={renderDetails()}
      renderMetadata={renderSpaMetadata}
      shouldRenderMobileDetails={shouldRenderMobileDetails}
      thumbnail={imageUrl}
      hidePrice={hidePrice || isOvernightPackage}
    />
  );
};
